import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './trainings.styles'
import TrainingsTable from './trainings-table/trainings-table.container'
import CurrentSkeleton from './trainings-skeleton/current-skeleton'
import octopus from './octopus.png'

class Trainings extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const { classes, pending, noTrainings } = this.props
    return noTrainings ? (
      <div>
        <img src={octopus} className={classes.illustration} alt="Not Found" />
        <p className={classes.container}>
          There are no training materials yet.
        </p>
      </div>
    ) : pending ? (
      <CurrentSkeleton />
    ) : (
      <>
        <TrainingsTable />
      </>
    )
  }
}

export default injectSheet(styles)(Trainings)
